const logout = async (url) => {
    const fetchResponse = await fetch(url, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Accept-API-Version": "resource=2.0,protocol=1.0"
        },
    });

    return fetchResponse;
};

export default logout;
